module.exports = __webpack_public_path__ + "img/gxs.bec82dba.svg";